import { Injectable, inject } from '@angular/core';
import { Firestore, collection, collectionData, addDoc, updateDoc, deleteDoc, doc, writeBatch } from '@angular/fire/firestore';
import { Observable, map } from 'rxjs';

export interface SmrsRate {
  id?: string;
  name: string;
  rate: number; // Percentage
  importKeys: string[]; // The values in "서버비 구분"
  importKey?: string; // Legacy support
  period?: string;
  order?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FeeRateService {
  private firestore = inject(Firestore);
  private collectionName = 'smrs_rates';

  getRates(): Observable<SmrsRate[]> {
    const ratesCol = collection(this.firestore, this.collectionName);
    return (collectionData(ratesCol, { idField: 'id' }) as Observable<SmrsRate[]>).pipe(
      map(data => data.map(r => ({
        ...r,
        importKeys: r.importKeys || (r.importKey ? [r.importKey] : [])
      })).sort((a, b) => (a.order || 0) - (b.order || 0)))
    );
  }

  async addRate(rate: SmrsRate): Promise<void> {
    const colRef = collection(this.firestore, this.collectionName);
    await addDoc(colRef, rate);
  }

  async updateRate(rate: SmrsRate): Promise<void> {
    if (!rate.id) return;
    const docRef = doc(this.firestore, this.collectionName, rate.id);
    await updateDoc(docRef, { ...rate });
  }

  async deleteRate(id: string): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    await deleteDoc(docRef);
  }

  async batchSave(ratesToDelete: string[], ratesToSave: SmrsRate[]): Promise<void> {
    const batch = writeBatch(this.firestore);

    ratesToDelete.forEach(id => {
      batch.delete(doc(this.firestore, this.collectionName, id));
    });

    ratesToSave.forEach(rate => {
      if (rate.id) {
        const ref = doc(this.firestore, this.collectionName, rate.id);
        batch.update(ref, { ...rate });
      } else {
        const ref = doc(collection(this.firestore, this.collectionName));
        batch.set(ref, { ...rate });
      }
    });

    await batch.commit();
  }
}
